<template>
	<div class="modal-erro">
		<div class="row">
			<div class="col-md-12">
				<p>{{ _traducao('global', 'esqueciMinhaSenha').toUpperCase() }}</p>
			</div>
		</div>

		<hr style="margin-top: 0px; margin-bottom: 0px" />

		<div v-show="exibirLogin">
			<div class="row">
				<div class="col-xs-12 text-center">
					<p style="font-size: 18px; margin-top: 20px; margin-bottom: 20px">
						<!--  Esqueceu sua senha? <br/> Digite seu login que enviaremos um link para definir uma nova senha. -->
						{{ _traducao('global', 'esqueceuSuaSenha') }} <br />
						{{ _traducao('global', 'textoDigiteSeuLogin') }}
					</p>
				</div>
			</div>

			<div class="row">
				<div class="col-md-3"></div>
				<div class="col-md-6 col-xs-12">
					<div class="form-group" :class="{'has-error': erro != ''}">
						<label>Login: </label>
						<input type="text" v-model="login" class="form-control input-sm" />
						<p class="help-block" v-show="erro != ''">{{ erro }}</p>
					</div>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-6">
					<button
						data-dismiss="modal"
						aria-label="Close"
						class="btn btn-default"
					>
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>
				<div class="col-xs-6">
					<button
						@click="clickCarregarContatos"
						class="btn btn-success pull-right"
					>
						{{ _traducao('global', 'avancar').toUpperCase() }}
						<i class="fa fa-arrow-right" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>

		<div v-show="tudoOk">
			<div class="row">
				<div class="col-xs-12 text-center">
					<h3 class="text-success">
						<i
							class="fa fa-check-circle fa-fw"
							style="font-size: 60px; margin-bottom: 16px"
						></i>
						<br />
						{{ usuario.nome.split(' ')[0] }}, tudo certo!
					</h3>
					<h3>
						{{ _traducao('global', 'enviamosUmEmail') }} ({{
							usuario.emailTratado
						}})
					</h3>
					<h3>
						{{ _traducao('global', 'comUmLink') }}
					</h3>
					<button
						data-dismiss="modal"
						aria-label="Close"
						style="margin-bottom: 20px; margin-top: 20px"
						class="btn btn-lg btn-default"
					>
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var jwt_token = require('jwt-decode')

export default {
	props: ['name'],

	data: function () {
		return {
			login: '',
			erro: '',
			exibirLogin: true,
			tudoOk: false,
			usuario: {
				email: '',
				emailTratado: '',
				tel1: '',
				tel2: '',
				id: 0,
				nome: ''
			}
		}
	},

	mounted() {
		var self = this

		bus.$on('carrega-esqueci-senha', (obj) => {
			self.login = obj
			;(self.erro = ''), (self.exibirLogin = true)
			self.tudoOk = false
			self.usuario = {
				email: '',
				emailTratado: '',
				tel1: '',
				tel2: '',
				id: 0,
				nome: ''
			}
		})
	},

	methods: {
		enviaSenha: function () {
			var self = this

			this.usuario.emailTratado = this.trataEmail(this.usuario.email)

			var data = {
				id_usuario: this.usuario.id,
				email: this.usuario.email
			}

			jQuery.ajax({
				type: 'POST',
				headers: {Authorization: this.token},
				url: this.getURL_WS('Usuario/valida_usuario/'),
				data: {data: JSON.stringify(data)},
				dataType: 'json',
				success: function (retorno) {
					//console.log(retorno)

					bus.$emit('load-out')
					// deu certo, Login ok!
					if (retorno.status == 'sucesso') {
						self.exibirLogin = false
						self.tudoOk = true
						//bus.$emit('alterou-senha');
					} else {
						self.erro =
							'Aconteceu algum problema ao recuperar a sua senha, caso persista o erro, entre em contato.'
						//bus.$emit('exibir-notificacao', {type: 'danger', text : "Não foi encontrado nenhum dado através desse login."})
					}
				},
				error: function (e) {
					//console.log(e);
					//console.log("aii");
					bus.$emit('modal-erro-show', e)
				}
			})
		},

		trataEmail: function (email) {
			var aux = email.split('@')
			var text =
				aux[0].substring(0, 3) +
				'********' +
				aux[0].substring(aux[0].length - 2, aux[0].length)

			return text + '@' + aux[1]
		},

		clickCarregarContatos: function () {
			this.login += ''
			if (this.login.trim() == '') {
				this.erro = this._traducao('global', 'digiteSeuLogin')
			} else {
				// bus.$emit('load-in', {text: this._traducao('global', 'alterandoSenha')})
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				var self = this
				this._carregaContatos((response) => {
					if (response.usuario) {
						self.usuario = response.usuario
						self.erro = ''
						self.enviaSenha()
					} else {
						self.erro = this._traducao('global', 'naoFoiPossivelEncontrarDados')
						bus.$emit('exibir-notificacao', {type: 'danger', text: self.erro})
						bus.$emit('load-out')
					}
				}, this.login)
			}
		}
	}
}
</script>